import { useState } from 'react';
import { isClient } from '../constants/env';

const createFeedback = async (onSuccess: () => void) => {
  window.Userback = window.Userback || ({} as keyof typeof window.Userback);
  const Userback = window.Userback;

  if (!Userback.open) {
    Userback.access_token = '34534|66573|1bKFdXMdJo3UAgzu8pJ8pHbWD';
    Userback.widget_settings = { trigger_type: 'api' };
    Userback.on_load = () => {
      Userback.open();
      onSuccess();
    };
    const script = document.createElement('script');
    script.src = 'https://static.userback.io/widget/v1.js';
    document.body.appendChild(script);
  } else {
    Userback.open();
    onSuccess();
  }
};

const useCreateFeedback = () => {
  useState(() => isClient && (window.createFeedback = createFeedback));
};

export default useCreateFeedback;
